<template>
  <div class="journey-group">
    <!-- FILTERS -->
    <div class="mt-1 mb-5" :class="pathMixin_isMeeting ? 'box' : ''">
      <FlightFilters
        v-model="filters"
        :filterOptions="filterOptions"
        :highlights="highlightedFilters"
        :preferredVendors="preferredVendors"
        :sortOptions="sortOptions"
        :unusedTickets="unusedTickets"
        :tripVal="tripVal"
        @clearFilters="defaultFilters()"
        @resetFilter="resetFilter"
      />
    </div>
    <!-- SELECTED FLIGHT BOX -->
    <div v-if="otherSelectedIdsCount" class="mb-5 is-hidden-touch">
      <div
        v-for="(uniqueKey, segmentIndex) in otherSelectedIds"
        :key="segmentIndex"
        data-test="selected_result_container"
      >
        <h3 class="is-size-6 mb-4 is-uppercase has-text-weight-bold">
          {{ journeyLabel(segmentIndex) }} Flight Selected
        </h3>

        <JourneyGroupItem
          data-test="selected_result"
          @unbundledJourneySelected="unbundledJourneySelected"
          :journey="getItem(uniqueKey, segmentIndex)"
          :segmentIndex="segmentIndex"
          :itineraryPrices="itineraryPrices"
          :rawItems="items"
          :preferredVendors="preferredVendors"
        />
      </div>
    </div>

    <!-- INFO ICONS (Legend) -->
    <div class="mb-2 pb-1 is-flex is-justify-content-center">
      <span class="ml-2 mr-2" v-if="$globals.ticketAirlines.length > 0">
        <b-icon icon="currency-usd" size="is-default" type="is-info"></b-icon>
        <span class="is-size-7 has-text-grey" style="margin-left: -5px;">
          = Unused Ticket Available</span
        >
      </span>
      <span class="ml-2 mr-2" v-if="isOneWay">
        <b-icon
          icon="alpha-f-circle"
          size="is-default"
          class="has-text-grey-lighter"
        />
        <span class="is-size-7 has-text-grey"> = Fare Rules</span>
      </span>
      <!--        <span class="ml-2 mr-2">-->
      <!--          <b-icon-->
      <!--                  icon="information"-->
      <!--                  size="is-default"-->
      <!--                  class="has-text-grey-lighter"-->
      <!--              />-->
      <!--          <span class="is-size-7 has-text-grey">Flight Details</span>-->
      <!--        </span>-->
    </div>

    <!--  HEADERS -->
    <div
      class="columns is-mobile is-gapless mb-0 pr-1 filters-container is-hidden-touch"
    >
      <!-- AIRLINE LOGO -->
      <div class="column is-narrow has-text-centered wrap">
        <div class="mt-1 airlineLogo"></div>
      </div>
      <!-- FROM-TO -->
      <div class="column is-narrow" style="width:150px">
        <span class="sbs-table-header">From-To</span>
      </div>
      <!-- DEPARTURE-ARRIVAl -->
      <div class="column is-narrow" style="width:200px">
        <span class="sbs-table-header">Departure-Arrival</span>
      </div>
      <!-- DURATION -->
      <div class="column has-text-left" >
        <span class="sbs-table-header">Duration & Stops</span>
      </div>
      <!-- UNUSED TICKET -->
      <div class="column has-text-centered is-narrow" style="width:40px;">
        <span class="sbs-table-header" v-if="$globals.ticketAirlines.length > 0"
          >$</span
        >
      </div>
      <!-- PRICE RANGE -->
      <div
        class="column is-narrow mr-2"
        style="width:120px"
        :class="isOneWay ? 'has-text-right' : 'has-text-centered'"
      >
        <span class="sbs-table-header ml-3">Price</span>
      </div>
      <!-- FARE RULES (One-Way Only) -->
      <div
        class="column is-narrow has-text-left"
        v-if="isOneWay"
        style="width:40px;"
      >
        <span class="sbs-table-header">
          Fare
        </span>
      </div>
      <!-- FLIGHT INFO -->
      <div class="column is-narrow" style="width: 100px;"></div>
      <!-- SELECT/DESELECT BUTTONS -->
      <div class="column is-narrow mr-2" style="width: 70px;"></div>
    </div>

    <div v-if="sortedJourneys.length == 0" style="text-align: center;">
      <b-message type="is-danger">
        No results found. <br />
        <br />
        Try removing some filters to see more results <br />
        <br />
        <b-button @click="defaultFilters" type="is-primary is-small"
          >Restore defaults</b-button
        >
      </b-message>
    </div>

    <div v-else class="flightResultsContainer" data-test="sbs_results_container">
      <DynamicScroller
        page-mode
        :items="sortedJourneys.slice(0)"
        :buffer="200"
        :min-item-size="59"
        class="scroller"
        key-field="uniqueKey"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
          >
            <JourneyGroupItem
              @unbundledJourneySelected="unbundledJourneySelected"
              :key="index"
              :journey="item"
              :segmentIndex="item.segmentIndex"
              :itineraryPrices="itineraryPrices"
              :raw-items="items"
              :preferredVendors="preferredVendors"
            />
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>

      <!-- LOADING MESSAGE -->
      <div v-if="segmentIndex == 2" class="mt-5">
        <div
          v-if="$store.state.bookTravel.flightSearchLoadingStatus"
          class="pt-1 pb-2 pr-0"
        >
          <b-message type="is-info" class="has-text-centered">
            <span class="gant-text"
              >Please wait while we're searching for additional flights.
            </span>
            <ReloadIcon style="width: 30px;" />
          </b-message>
        </div>
        <!--
      <div v-else class="mt-5">
        <div
          v-if="
            $store.state.bookTravel.flightSearchComplete && moreResults.length == 0   
          "
        >
          <b-message type="is-info has-text-centered">
            No additional results were found.
          </b-message>
        </div>
        <div v-if="loadingMoreResults.isSearch && (moreResults.length > 0 && !loadingMoreResults.errors)" class="pt-1 pb-2 pr-0">
          <b-message type="is-info has-text-centered">
            We found {{moreResults.length }} flights.
          </b-message>
        </div> 
      </div>
      --></div>

      <!-- MORE RESULTS LOADER BELOW -->

      <MoreFlightResultsLoader
        :filters="filters"
        :highlightedFilters="highlightedFilters"
        :filterOptions="moreResultsFilterOptions"
        @clearFilters="defaultFilters()"
        @resetFilter="resetFilter"
        @searchTargetedAirlines="searchTargetedAirlines"
      />

      <!-- END MORE RESULTS LOADER -->
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin";
import flightFilterMixin from "@/mixins/flightFilterMixin";
import { mapState } from "vuex";
let moment = require("moment");
import JourneyGroupItem from "./JourneyGroupItem.vue";
import FlightFilters from "../../Filters/FlightFilters.vue";
import ReloadIcon from "/public/images/SVGs/Reload-1s-200px.svg";
import MoreFlightResultsLoader from "@/components/BookTravel/Air/MoreFlightResultsLoader";
import {
  RecycleScroller,
  DynamicScroller,
  DynamicScrollerItem,
} from "vue-virtual-scroller";

export default {
  components: {
    JourneyGroupItem,
    FlightFilters,
    MoreFlightResultsLoader,
    ReloadIcon,
    DynamicScroller,
    DynamicScrollerItem,
  },
  mixins: [bookingMixin, flightFilterMixin],
  props: {
    segmentIndex: null,
    items: Array,
    tripVal: Number,
    journeyItems: Array,
    groupedByJourney: Object,
    itineraryPrices: Array,
  },
  data() {
    return {
      selectedLegCounts: [],
    };
  },
  watch: {},
  computed: {
    ...mapState(["bookTravel"]),
    allAirlines(){
      return this.getAirlines(this.journeyItems);
    },
    filteredAirlines(){
      return this.getAirlines(this.filterJourneys("airline")); //airlines filter
    },
    filterOptions() {
      return {
        allAirlines: this.allAirlines,
        filteredAirlines: this.filteredAirlines,
        unusedTickets: this.unusedTickets,
        stops: this.getStopsOptions(),
        //times: this.getTimesOptions(),
        tripVal: this.tripVal,
        priceData: null,
        availablePolicies: null,
        highestRating: null,
        ndc: null
      };
    },

    sortOptions() {
      let options = [
        { value: "earliestDeparture", label: "Departure Time" },
        { value: "earliestArrival", label: "Arrival Time" },
        { value: "duration", label: "Duration" },
      ];

      if (this.preferredVendors.length > 0) {
        options.push({
          value: "Preferred Vendors",
          label: "Preferred Airlines",
        });
      }

      return options;
    },

    //filter options for the More Results loader
    moreResultsFilterOptions() {
      return {
        allAirlines: this.allAirlines,
        filteredAirlines: this.filteredAirlines,
        unusedTickets: null,
        stops: null,
        tripVal: this.tripVal,
        priceData: null,
        availablePolicies: null,
        highestRating: null,
      };
    },

    filteredJourneys() {
      return this.filterJourneys();
    },

    //Generate list of matching journeys for a selected journey
    //(i.e. matching return flights for a given outbound flight or vice versa)
    matchingJourneys() {
      let otherSelectedIds = this.otherSelectedIds;
      // identify raw options that contain the other selected journeys
      let rawItems = this.items.filter((item) => {
        for (let journey of item.journeys) {
          let uniqueKey = journey.uniqueKey;
          let segmentIndex = journey.segmentIndex;

          if (otherSelectedIds[segmentIndex] !== undefined) {
            return otherSelectedIds[segmentIndex] == uniqueKey;
          }
        }

        return true;
      });

      let matchingCurrentJourneys = [];
      for (let item of rawItems) {
        for (let journey of item.journeys) {
          if (journey.segmentIndex == this.segmentIndex) {
            matchingCurrentJourneys.push(journey.uniqueKey);
          }
        }
      }

      let matchingJourneys = this.journeyItems.filter((item) => {
        return matchingCurrentJourneys.includes(item.uniqueKey);
      });

      return matchingJourneys;
    },

    sortedJourneys() {
      return this.sortJourneys(this.filteredJourneys);
    },

    //list containing unique ids of selected journeys
    selectedJourneyIds() {
      return this.bookTravel.selectedUnbundledJourneys;
    },
    otherSelectedIds() {
      // Remove the current index
      let selected = Object.assign({}, this.selectedJourneyIds);
      delete selected[this.segmentIndex];
      return selected;
    },
    otherSelectedIdsCount() {
      return Object.keys(this.otherSelectedIds).length;
    },
    currentSelectedJourney() {
      return this.selectedJourneyIds[this.segmentIndex];
    },
    unusedTickets() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].unusedTicketAirlines;
    },
    availablePolicies() {
      return this.getPolicies(this.filteredJourneys);
    },
    highestRating() {
      return this.getHighestRating(this.filteredJourneys);
    },
    unusedTicketsOnly() {
      return this.filters.unusedTicketsOnly;
    },
    sortOrder() {
      return this.filters.sortOrder;
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ];
    },
    preferredVendors() {
      return this.profile.preferredAirVendors || [];
    },
    flightSearchLoadingStatus() {
      return this.$store.state.bookTravel.flightSearchLoadingStatus;
    },
  },
  methods: {
    filterJourneys(ignore = null) {
      // ====================
      // Apply custom filters
      // ====================

      let filteredItems = this.matchingJourneys;

      //MT - Disabled NDC filter in Search By Schedule
      /*
      if (this.filters.ndc === "Exclude NDC") {
        filteredItems = filteredItems.filter(item => !item.isNdc);
      }

      if (this.filters.ndc === "NDC Only") {
        filteredItems = filteredItems.filter(item => item.isNdc);
      }
      */

      // Filter by airline code unless "ignore" flag is set

      if (this.filters.selectedAirlines.length > 0 && ignore != "airline") {
        filteredItems = filteredItems.filter((item) => {
          let selectedAirlineCodes = this.filters.selectedAirlines.map(
            (a) => a.code
          );
          if (selectedAirlineCodes.includes(item.airlineCode)) {
            return true;
          }
        });
      }

      /*
      // Filter by legs count
      if (this.selectedLegCounts.length > 0) {
        filteredItems = filteredItems.filter((item) => {
          return this.selectedLegCounts.some(
            (legsCount) => item.legsCount == legsCount
          );
        });
      }
      */

      //Filter by time of day
      if (this.filters.timeRangeSegment1.segment == 1) {
        filteredItems = filteredItems.filter((i) => {
          var date = new Date(
            i.journeys[0].legs.slice(-1).pop().arrivingAt.date +
              "T" +
              i.journeys[0].legs.slice(-1).pop().arrivingAt.time
          );
          return (
            date.getHours() >= this.filters.timeRangeSegment1.range[0] &&
            date.getHours() <= this.filters.timeRangeSegment1.range[1]
          );
        });
      }

      // Filter by number of stops
      if (this.filters.maxStopsSegment1 !== "") {
        filteredItems = filteredItems.filter((item) => {
          return item.legs.length - 1 <= this.filters.maxStopsSegment1;
        });
      }

      // Show only unused tickets
      if (this.filters.unusedTicketsOnly) {
        filteredItems = filteredItems.filter((item) => {
          return this.unusedTickets.includes(item.airlineCode);
        });
      }

      return filteredItems;
    },

    sortJourneys(journeys) {
      //let sortedItems = this.filteredJourneys;

      // console.log('sortedItems', sortedItems);

      //let sortBy = this.sortBy;
      // earliest, quickest, cheapest
      // console.log('sort by: ' + sortBy)
      if (this.filters.sortOrder == "earliestDeparture") {
        journeys = journeys.sort((a, b) => {
          var dateA = moment(a.startDate + "T" + a.startTime);
          var dateB = moment(b.startDate + "T" + b.startTime);
          return dateA - dateB;
        });
      } else if (this.filters.sortOrder == "earliestArrival") {
        journeys = journeys.sort((a, b) => {
          var dateA = moment(a.endDate + "T" + a.endTime);
          var dateB = moment(b.endDate + "T" + b.endTime);
          return dateA - dateB;
        });
      } else if (this.filters.sortOrder == "duration") {
        journeys = journeys.sort((a, b) => a.travelDuration - b.travelDuration);
      } else if (this.filters.sortOrder == "priceDESC") {
        journeys = journeys.sort((a, b) => a.pricing.total - b.pricing.total);
      } else if (this.filters.sortOrder == "priceASC") {
        journeys = journeys.sort((a, b) => b.pricing.total - a.pricing.total);
      } else if (this.filters.sortOrder == "Preferred Vendors") {
        journeys.sort((a, b) => {
          return this.preferredVendors.includes(a.airlineCode)
            ? -1
            : this.preferredVendors.includes(b.airlineCode)
            ? 1
            : 0;
        });
      }

      return journeys;
    },

    getAirlines(items) {
      let distinctAirlines = [];
      let sortedAirlines = [];

      for (let item of items) {
        let airlineCode = item.airlineCode;

        if (distinctAirlines[airlineCode] === undefined) {
          distinctAirlines[airlineCode] = 1;
        } else {
          distinctAirlines[airlineCode]++;
        }
      }

      // Sort airline codes A-Z
      let sortedAirlineKeys = Object.keys(distinctAirlines).sort();

      // Build sorted list
      for (let key of sortedAirlineKeys) {
        let airline = {
          code: key,
          name: this.$helpers.airlineName(key),
          resultsCount: distinctAirlines[key],
        };
        sortedAirlines.push(airline);
      }

      return sortedAirlines;
    },

    //Build array of options for "Stops" dropdown
    getStopsOptions() {
      let items = this.journeyItems;
      let layoverCounts = [];
      let options = [
        {
          value: "",
          label: "Any",
          count: 0,
        },
      ];

      for (let item of items) {
        let stops = item.legsCount - 1;

        if (layoverCounts[stops] === undefined) {
          layoverCounts[stops] = 1;
        } else {
          layoverCounts[stops]++;
        }
      }

      // Sort low to high
      layoverCounts = Object.keys(layoverCounts).sort();

      // Build sorted list
      for (let stops of layoverCounts) {
        let option = {
          value: Number(stops),
          label: this.$helpers.stopsLabels(stops),
          count: Number(layoverCounts[stops]),
        };
        options.push(option);
      }

      return [{ name: "", options: options }];
    },

    getTimesOptions() {
      let options = [{ name: "" }];
      return options;
    },

    searchTargetedAirlines(targetedAirlines) {
      //this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", true);

      //reduce array of objects to simple array of airline codes
      //let targetedAirlines = targetedAirlinesObj.map((a) => a.code);

      this.$emit("searchTargetedAirlines", targetedAirlines);
    },
    removeCurrentSelectedJourney(segmentIndex) {
      // console.log('option unselected: ' + segmentIndex)
      this.$store.commit("bookTravel/UNSELECT_UNBUNDLED_JOURNEY", segmentIndex);
    },
    getItem(uniqueKey, segmentIndex) {
      let items = this.groupedByJourney[segmentIndex];

      // Filter the items
      let filteredItems = items.filter((item) => {
        return item.uniqueKey == uniqueKey;
      });

      return filteredItems[0];
    },
    unbundledJourneySelected(segmentIndex) {
      // console.log('unbundledJourneySelected > JourneyGroup: ' + segmentIndex)
      this.$emit("unbundledJourneySelected", segmentIndex);
    },
  },
  created() {
    this.TRIP_ONE_WAY = 0;
    this.TRIP_ROUNDTRIP = 1;
    this.TRIP_MULTI_CITY = 2;
    this.ARRIVAL_TIME = 1;
    this.DEPARTURE_TIME = 0;
  },
  mounted() {
    //set default sort order
    this.filters.sortOrder = "earliestDeparture";
  },
};
</script>

<style scoped></style>
